import { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function CategoryManager({ onClose }) {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);   // category name being renamed
  const [editVal, setEditVal] = useState('');
  const [deleting, setDeleting] = useState(null);  // category name being deleted
  const [reassign, setReassign] = useState('');    // target for delete-reassign ('' = clear)

  const load = () => api.get('/api/products/categories')
    .then(r => { setCats(r.data.categories); setLoading(false); })
    .catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const doRename = async (from) => {
    const to = editVal.trim();
    if (!to) return toast.error('Enter a new name');
    try {
      const r = await api.post('/api/products/categories/rename', { from, to });
      const existed = cats.some(c => c.name === to && c.name !== from);
      toast.success(existed ? `Merged into “${to}” (${r.data.updated} items)` : `Renamed (${r.data.updated} items)`);
      setEditing(null); setEditVal(''); load();
    } catch (e) { toast.error(e.response?.data?.error || 'Rename failed'); }
  };

  const doDelete = async (name) => {
    try {
      const r = await api.post('/api/products/categories/delete', { name, reassign_to: reassign });
      toast.success(reassign ? `Moved ${r.data.updated} items to “${reassign}”` : `Cleared category on ${r.data.updated} items`);
      setDeleting(null); setReassign(''); load();
    } catch (e) { toast.error(e.response?.data?.error || 'Delete failed'); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Manage Categories</h3>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <p className="form-hint" style={{ marginTop: 0 }}>
            Rename updates every item at once. Renaming to an existing name merges them.
            Deleting reassigns items to another category or clears the field.
          </p>
          {loading ? <div className="loading">Loading…</div>
            : cats.length === 0 ? <p className="text-muted">No categories in use yet.</p>
            : (
              <table style={{ fontSize: 14 }}>
                <thead><tr><th>Category</th><th>Items</th><th style={{ textAlign: 'right' }}>Actions</th></tr></thead>
                <tbody>
                  {cats.map(c => (
                    <tr key={c.name}>
                      {editing === c.name ? (
                        <>
                          <td colSpan={2}>
                            <input className="form-input" value={editVal} autoFocus
                              onChange={e => setEditVal(e.target.value)}
                              onKeyDown={e => e.key === 'Enter' && doRename(c.name)} />
                          </td>
                          <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <button className="btn btn-primary btn-sm" onClick={() => doRename(c.name)}>Save</button>
                            <button className="btn btn-ghost btn-sm" onClick={() => setEditing(null)}>Cancel</button>
                          </td>
                        </>
                      ) : deleting === c.name ? (
                        <>
                          <td colSpan={2}>
                            <span className="text-sm">Move its items to: </span>
                            <select className="form-select" style={{ display: 'inline-block', width: 'auto' }}
                              value={reassign} onChange={e => setReassign(e.target.value)}>
                              <option value="">— clear category —</option>
                              {cats.filter(x => x.name !== c.name).map(x => <option key={x.name} value={x.name}>{x.name}</option>)}
                            </select>
                          </td>
                          <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <button className="btn btn-primary btn-sm" style={{ background: 'var(--brand-red)' }} onClick={() => doDelete(c.name)}>Confirm</button>
                            <button className="btn btn-ghost btn-sm" onClick={() => { setDeleting(null); setReassign(''); }}>Cancel</button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td><strong>{c.name}</strong></td>
                          <td>{c.count}</td>
                          <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <button className="btn btn-secondary btn-sm" onClick={() => { setEditing(c.name); setEditVal(c.name); }}>Rename</button>
                            <button className="btn btn-ghost btn-sm" onClick={() => { setDeleting(c.name); setReassign(''); }}>Delete</button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
}
